import { render, staticRenderFns } from "./FreeTool.vue?vue&type=template&id=10b2b9ce&scoped=true"
import script from "./FreeTool.vue?vue&type=script&lang=js"
export * from "./FreeTool.vue?vue&type=script&lang=js"
import style0 from "./FreeTool.vue?vue&type=style&index=0&id=10b2b9ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b2b9ce",
  null
  
)

export default component.exports